<template>
    <div>
        <div :class="addClassesForTextColor?'text-warning':'' + 'font-weight-light'" v-if="auflageLeft > 0">
            {{'versandaufteilungNochZuVerteilen'|translate(auflageLeft)}}
        </div>
        <div class="text-error font-weight-light" v-else-if="auflageLeft < 0">
            {{'versandaufteilungZuvielVerteilt'|translate(-auflageLeft)}}
        </div>
        <div class="text-error font-weight-light" v-else-if="hasEmptyAddresses">
            {{'versandaufteilungLeereAdressen'|translate}}
        </div>
        <div class="text-success font-weight-light" v-else>
            {{'versandaufteilungAlleVerteilt'|translate}}
        </div>
    </div>
</template>

<script>
    export default {
        name: "VersandaufteilungIndicator",
        props: { 
            auflageLeft: Number,
            addClassesForTextColor: { type: Boolean, required: false, default: true},
            hasEmptyAddresses: Boolean
        }
    }
</script>

<style scoped>
    .config-group div.text-error {
        color: #fc4a40 !important;
        padding: 0;
        position: static;
        border: none !important;
    }
</style>